import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Stack,
  Checkbox,
  Input,
  InputGroup,
  InputLeftAddon,
} from "@chakra-ui/react";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ColumnsPopover = ({
  columns,
  setColumns,
  fixedFields,
}: {
  columns: any[];
  setColumns: (columns: any[]) => void;
  fixedFields: any[];
}) => {
  const [filterColumns, setFilterColumns] = useState("");
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  const toggleShow = (id: string, show: boolean) => {
    // const targetColumn = columns.find((col) => col.id === id);

    const updatedColumns = columns.map((col) => {
      if (col.id === id) {
        return {
          ...col,
          show,
        };
      }
      return col;
    });
    setColumns(updatedColumns);
  };

  const handleSelectAll = (checked: any) => {
    setSelectAllChecked(checked);

    const fixedFieldIds = fixedFields.map((field: any) => field.id);

    const updatedColumns = columns.map((col: any) => {
      if (fixedFieldIds.includes(col.id)) {
        return { ...col, show: true };
      } else {
        return { ...col, show: checked };
      }
    });

    setColumns(updatedColumns);
  };

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Button
          variant="outline"
          leftIcon={<FontAwesomeIcon icon={["far", "columns"]} />}
        >
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent
        borderRadius="8px"
        borderWidth="1.5px"
        borderColor="#E0E0E0"
        boxShadow="0px 0px 5px 1px rgba(152, 152, 152, 0.25)"
      >
        <PopoverArrow />
        <PopoverBody p="0px">
          <InputGroup borderBottomWidth="1px" borderBottomColor="#E0E0E0">
            <InputLeftAddon
              px="12px"
              children={
                <FontAwesomeIcon
                  icon={["fal", "search"]}
                  color="gray.300"
                  fontSize="14px"
                />
              }
            />
            <Input
              value={filterColumns}
              onChange={(ev) => setFilterColumns(ev.target.value)}
              variant="unstyled"
              placeholder="Search columns..."
              fontSize="13px"
              color="gray.300"
              // height="40px"
            />
          </InputGroup>
          <Stack p="12px" maxH="240px" overflowY="scroll">
            <Checkbox
              fontSize="14px"
              color="#595959"
              fontWeight="500"
              isChecked={selectAllChecked}
              onChange={(e) => handleSelectAll(e.target.checked)}
              mr={2}
            >
              Select All
            </Checkbox>
            {columns
              .filter((column: any) =>
                column.label
                  .toLowerCase()
                  .includes(filterColumns.toLowerCase()),
              )
              .map((field: any) => (
                <Checkbox
                  fontSize="14px"
                  color="#595959"
                  fontWeight="500"
                  key={field.id}
                  onChange={(e) => toggleShow(field.id, e.target.checked)}
                  isChecked={columns.find((col) => col.id === field.id)?.show}
                >
                  {field.label}
                </Checkbox>
              ))}
          </Stack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ColumnsPopover;
